const t = [
  /^https?:\/\//,
  /^http?:\/\//,
  /^ftp?:\/\//,
  /^ftps?:\/\//,
  /^ftps?:\/\//,
  /mailto:([^?]*)/
], s = "https://", O = "#000000", _ = {
  EDITOR_SUPPORTED_LINK_PROTOCOLS: t,
  EDITOR_DEFAULT_LINK_PREFIX: s,
  EDITOR_DEFAULT_FONT_COLOR: O
};
export {
  O as EDITOR_DEFAULT_FONT_COLOR,
  s as EDITOR_DEFAULT_LINK_PREFIX,
  t as EDITOR_SUPPORTED_LINK_PROTOCOLS,
  _ as default
};
//# sourceMappingURL=editor-constants.js.map
